import { render, staticRenderFns } from "./AdInsightsPanel.vue?vue&type=template&id=1c621f06&scoped=true"
import script from "./AdInsightsPanel.vue?vue&type=script&lang=js"
export * from "./AdInsightsPanel.vue?vue&type=script&lang=js"
import style0 from "./AdInsightsPanel.vue?vue&type=style&index=0&id=1c621f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c621f06",
  null
  
)

export default component.exports